/* Maverick Metals — collection: sort navigation + mobile filter toggle.
   Filtering itself is native (server-side via filter links); this only
   handles the sort dropdown and showing/hiding the rail on mobile. */
(function () {
  var root = document.querySelector('[data-mm-collection]');
  if (!root) return;

  var sort = root.querySelector('[data-mm-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
  }

  var toggle = root.querySelector('[data-mm-filter-toggle]');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('mm-coll--filters-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Filters −' : 'Filters +';
    });
  }
})();
